<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
  components: {
  }
}
</script>

<style lang="less">
* {
  margin: 0;
  padding: 0;
  background-size: 100% 100%;
  box-sizing: border-box;
}



html {
  width: 100vw !important;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue